import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=6e67a634&scoped=true"
import script from "./DetailsTab.vue?vue&type=script&lang=js"
export * from "./DetailsTab.vue?vue&type=script&lang=js"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=6e67a634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67a634",
  null
  
)

export default component.exports